"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ACSParticipantDisplayName;
(function (ACSParticipantDisplayName) {
    ACSParticipantDisplayName["Customer"] = "Customer";
    ACSParticipantDisplayName["Agent"] = "__agent__";
    ACSParticipantDisplayName["System"] = "__system__";
})(ACSParticipantDisplayName || (ACSParticipantDisplayName = {}));
exports.default = ACSParticipantDisplayName;
//# sourceMappingURL=ACSParticipantDisplayName.js.map